module.exports = __webpack_public_path__ + "img/onboardAi.2667933b.png";